export default {
    variants: {
        textWithSymbol: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: 'regular',
            _after: {
                color: 'primaryBlack',
                fontSize: '17px'
            }
        },
        drawerTitle: {
            textStyle: 'webH3'
        },
        infoCardTitle: {
            fontSize: {base: 'xs', lg: 'sm'},
            fontWeight: 'normal',
            color: 'webTypo.textPrimary',
            textTransform: 'none'
        },
        infoCardText: {
            fontSize: 'sm',
            fontWeight: 'normal',
            color: 'webTypo.textSecondary'
        },
        smartSearchHeading: {
            textStyle: 'bodyMdRegular'
        }
    }
}
